export default __webpack_public_path__ + "static/media/Logo quoc Loc Phat-04.98020ee0.png";